package com.patronat.top.ui.atoms

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.*

@Composable
fun AppTabSelector(
    options: List<String>,
    selectedIndex: Int,
    onOptionSelected: (Int) -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier
            .fillMaxWidth() // Ряд займає всю ширину, але контент буде зліва
            .height(IntrinsicSize.Min),
        verticalAlignment = Alignment.Bottom
    ) {
        options.forEachIndexed { index, title ->
            val isSelected = index == selectedIndex
            val interactionSource = remember { MutableInteractionSource() }

            val textColor by animateColorAsState(
                targetValue = if (isSelected) MineShaft950 else MineShaft500,
                animationSpec = tween(durationMillis = 300, easing = FastOutSlowInEasing),
                label = "TabTextColor"
            )

            val lineColor by animateColorAsState(
                targetValue = if (isSelected) MineShaft950 else Color.Transparent,
                animationSpec = tween(durationMillis = 300, easing = FastOutSlowInEasing),
                label = "TabLineColor"
            )

            Box(
                modifier = Modifier
                    .clickable(
                        interactionSource = interactionSource,
                        indication = null
                    ) { onOptionSelected(index) }
                    .padding(end = 24.dp),
                contentAlignment = Alignment.BottomCenter
            ) {
                Column(
                    modifier = Modifier.width(IntrinsicSize.Max),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        text = title,
                        style = TabTextStyle,
                        color = textColor,
                        // Вертикальні відступи
                        modifier = Modifier.padding(top = 12.dp, bottom = 2.dp)
                    )
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(3.dp)
                            .background(lineColor)
                    )
                }
            }
        }
    }
}